import { findFirstChildWithTagName, isElement } from './dom';
export function getScte35String(element) {
    if (isElement(element)) {
        var match = element.getElementsByTagNameNS('urn:scte:scte35:2014:xml+bin', 'Binary');
        if (match.length > 0) {
            var _match__textContent;
            return (_match__textContent = match[0].textContent) !== null && _match__textContent !== void 0 ? _match__textContent : undefined;
        }
    } else {
        var signalElement = findFirstChildWithTagName('scte35:Signal', element);
        if (!signalElement) {
            return;
        }
        var binaryElement = findFirstChildWithTagName('scte35:Binary', signalElement);
        if (!binaryElement) {
            return;
        }
        var scte35TagValue = binaryElement.children.find(function(c) {
            return typeof c === 'string';
        });
        return scte35TagValue;
    }
}

//# sourceMappingURL=dash-scte35-extractor.js.map